import React from 'react'
import type { FieldValue } from '../../../../ai-viewer/eventing/types'

interface FieldsSummaryPanelProps {
  fields: FieldValue[]
}

export const FieldsSummaryPanel: React.FC<FieldsSummaryPanelProps> = ({ fields }) => {
  if (fields.length === 0) {
    return null
  }

  return (
    <div className="absolute bottom-4 left-4 max-w-sm bg-white rounded shadow-lg p-3">
      <h3 className="text-sm font-semibold mb-2">Extracted Fields</h3>
      <div className="max-h-32 overflow-y-auto space-y-1">
        {fields.slice(0, 5).map(field => (
          <div key={field.key} className="flex items-center justify-between text-xs">
            <span className="text-gray-600">{field.key}:</span>
            <span className={`font-medium ${
              field.status === 'verified' ? 'text-green-600' : 
              field.status === 'rejected' ? 'text-red-600' : 
              'text-gray-900'
            }`}>
              {typeof field.value === 'number' && field.unit === 'USD' 
                ? `$${field.value.toFixed(2)}`
                : String(field.value)
              }
              {field.confidence && (
                <span className="ml-1 text-gray-400">
                  ({Math.round(field.confidence * 100)}%)
                </span>
              )}
            </span>
          </div>
        ))}
      </div>
      {fields.length > 5 && (
        <p className="text-xs text-gray-500 mt-2">
          +{fields.length - 5} more fields
        </p>
      )}
    </div>
  )
}

